import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { handleRenavigationError, idWithoutDotHtml } from '®shared/router';

import { ItemResolverStoreService } from '../resolver-store';

@Injectable()
export class CanActivateDraftItemView implements CanActivate {
  constructor(
    private itemResolverStoreService: ItemResolverStoreService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const itemId = idWithoutDotHtml(route.params.itemId);

    return this.itemResolverStoreService
      .hasDraftItem(itemId)
      .pipe(catchError(handleRenavigationError(this.router)));
  }
}
